import {
  Component,
  OnInit,
  Input
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-timing',
  templateUrl: './timing.component.html',
  styleUrls: ['./timing.component.css']
})
export class TimingComponent implements OnInit {
  @Input() time: number; // segundos
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    const interval = setInterval(() => {
      this.time --;
      if (this.time === 0) {
        clearInterval(interval);
        this.activeModal.close('OK');
      }
    }, 1000);
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/timing/timing.component.ts